import { render, staticRenderFns } from "./DownloadItem.vue?vue&type=template&id=c34af7c4&scoped=true"
import script from "./DownloadItem.vue?vue&type=script&lang=js"
export * from "./DownloadItem.vue?vue&type=script&lang=js"
import style0 from "./DownloadItem.vue?vue&type=style&index=0&id=c34af7c4&prod&lang=scss&scoped=true"
import style1 from "./DownloadItem.vue?vue&type=style&index=1&id=c34af7c4&prod&lang=scss&scoped=true"
import style2 from "./DownloadItem.vue?vue&type=style&index=2&id=c34af7c4&prod&lang=scss&scoped=true"
import style3 from "./DownloadItem.vue?vue&type=style&index=3&id=c34af7c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34af7c4",
  null
  
)

export default component.exports